import { render, staticRenderFns } from "./TablePresencas.vue?vue&type=template&id=352793c7&scoped=true"
import script from "./TablePresencas.vue?vue&type=script&lang=js"
export * from "./TablePresencas.vue?vue&type=script&lang=js"
import style0 from "./TablePresencas.vue?vue&type=style&index=0&id=352793c7&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "352793c7",
  null
  
)

export default component.exports